import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './vant-ui'
import axios from 'axios'
import 'dayjs/locale/zh-cn' // load on demand
import relativeTime from 'dayjs/plugin/relativeTime'
const dayjs = require('dayjs')
dayjs.extend(relativeTime)

Vue.config.productionTip = false
Vue.prototype.$fetch = axios
Vue.prototype.dayjs = dayjs
axios.interceptors.request.use(request => {
  return request
}, error => {
  // uni.showModal({
  //   title: '提示',
  //   content: '请求参数错误',
  //   showCancel: false,
  //   success: function (res) {}
  // })
  return Promise.reject(error)
})

// 添加响应拦截器，响应拦截器会在then/catch处理之前执行
axios.interceptors.response.use(
  (response) => {
    if (response.data.code !== 0) {
      // uni.showModal({
      //   title: '提示',
      //   content: response.data.msg,
      //   showCancel: false
      // })
      return Promise.reject(new Error('请求出错'))
    }
    // 只将请求结果的data字段返回
    return response.data
  },
  (err) => {
    // uni.hideLoading()
    // uni.showToast({
    //   title: '网络不稳定',
    //   duration: 1500,
    //   icon: 'none'
    // })
    return Promise.reject(err)
  }
)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
